<template>
  <el-dialog
    :visible.sync="modelValue"
    width="400px"
    center
    custom-class="relic-create"
    :before-close="handleCancelRelic"
  >
    <div class="create-title font-h3">新建建筑</div>
    <div class="create-name">
      <span>建筑编号:</span>
      <el-input
        v-model="relicNumber"
        type="text"
        placeholder="请填写编号"
      ></el-input>
    </div>
    <div class="create-name">
      <span>建筑名称:</span>
      <el-input
        v-model="relicName"
        type="text"
        placeholder="请填写名称"
      ></el-input>
    </div>
    <div class="create-name">
      <span>建筑年代:</span>
      <el-input
        v-model="relicAge"
        type="text"
        placeholder="请填写年代"
      ></el-input>
    </div>
    <div class="create-roles">
      <span class="title">建筑类别:</span>
      <el-select
        v-model="relicType"
        class="create-input__content font-labelheavy"
        popper-class="create-select"
      >
        <el-option
          v-for="item in relicTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="create-roles">
      <span class="title">保护级别:</span>
      <el-select
        v-model="protectLevelValue"
        class="create-input__content font-labelheavy"
        popper-class="create-select"
      >
        <el-option
          v-for="item in protectLevels"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="create-roles">
      <span class="title">所属区域:</span>
      <el-select
        v-model="area"
        class="create-input__content font-labelheavy"
        popper-class="create-select"
      >
        <el-option
          v-for="item in areas"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="create-btn">
      <el-button
        class="confirm-btn"
        @click="handleConfirmRelic"
        :class="{ 'is-active': relicAge && relicNumber && relicName }"
        >确定</el-button
      >
      <el-button class="cancel-btn" type="primary" @click="handleCancelRelic"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { modelMixin } from '../../assets/js/mixins/model';
import { createRelic } from '../../api/index';
import { SELECT_AREA, SELECT_LEVEL, SELECT_TYPE } from '../../config/constant';
export default {
  mixins: [modelMixin],
  data() {
    return {
      relicNumber: '',
      relicName: '',
      relicAge: '',
      relicTypes: SELECT_TYPE,
      relicType: 'GUYIZHI',
      protectLevels: SELECT_LEVEL,
      protectLevelValue: 'GUOBAO',
      areas: SELECT_AREA,
      area: 'CHENGXIANGJIEDAO'
    };
  },
  methods: {
    /**
     * 确认创建建筑回调
     */
    handleConfirmRelic() {
      if (this.relicNumber && this.relicName && this.relicAge) {
        createRelic({
          protectionLevelEnum: this.protectLevelValue,
          relicAge: this.relicAge,
          relicDistrictEnum: this.area,
          relicFromUserId: this.relicNumber,
          relicName: this.relicName,
          relicTypeEnum: this.relicType
        })
          .then(res => {
            if (res.data.code == 200) {
              this.relicAge = '';
              this.relicName = '';
              this.relicNumber = '';
              this.modelValue = false;
              this.$emit('onConfirmCreateRelic');
            } else if (res.data.code == 400) {
              this.$prompt('建筑编号不可重复！');
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },

    /**
     * 取消创建建筑回调
     */
    handleCancelRelic() {
      this.relicName = '';
      this.relicAge = '';
      this.relicNumber = '';
      this.$emit('onCancelCreateRelic');
    }
  }
};
</script>

<style lang="scss">
.relic-create {
  .el-dialog {
    &__header {
      padding: 0;
    }
    &__body {
      padding: 28px 24px;
      overflow-y: auto;
    }
    &__headerbtn {
      display: flex;
      font-size: 30px;
      color: #fff;
      top: -5px;
      right: -40px;
    }
    &__close {
      color: #fff;
    }
  }
  .create-title {
    padding-bottom: 10px;
    font-size: 16px;
    font-weight: 600;
    border-bottom: 1px solid $color-border-light;
  }
  .create-name {
    display: flex;
    justify-content: space-between;
    margin: 15px 0;
    span {
      margin-right: 15px;
      line-height: 30px;
    }
    .el-input {
      width: 250px;
      height: 30px;
      &__inner {
        width: 250px;
        height: 30px;
        border-radius: 0;
        padding-left: 5px;
        &:focus {
          border-color: $color-border-light;
        }
      }
    }
  }
  .create-roles {
    display: flex;
    justify-content: space-between;
    margin: 15px 0;
    .title {
      line-height: 30px;
    }
    .create-select {
      .el-select-dropdown {
        &__item {
          height: 20px;
          line-height: 20px;
          font-size: 13px;
          font-family: 'Arial Negreta';
        }
      }
    }
    .create-input__content {
      margin-left: 34px;
      width: 250px;
      .el-input,
      .el-textarea {
        &__inner {
          padding: 0 3px;
          height: 30px;
          font-size: 13px;
          line-height: 30px;
          resize: none;
          border-radius: unset;
          border: 1px solid $color-border-light !important;
          box-shadow: 0;
        }
        &__suffix {
          &-inner {
            display: flex;
            align-items: center;
            height: 100%;
          }
        }
      }
      .el-textarea__inner {
        line-height: 18px;
      }
      .el-select {
        &__caret {
          color: #000 !important;
          font-weight: bold;
          font-size: 12px !important;
          line-height: 1;
        }
      }
    }
  }
  .create-btn {
    display: flex;
    justify-content: center;
    margin-top: 35px;
    .el-button {
      border: 0;
    }
    .confirm-btn {
      margin-right: 20px;
      background-color: $color-disabled;
      font-size: 13px;
      color: #fff;
    }
    .is-active {
      background-color: $color-primary;
    }
  }
}
</style>
